import React from 'react'

import { Button, Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
// Shared user-data fetch (avatar + username); also used by LegacyNavigation.
import { useUserData } from 'Pods/UnifiedNavigation/Hooks/useUserData'

import { NOOP } from 'Utils/stableDefaults'

// Right-hand user section: Log in / Sign up for guests, avatar for signed-in users.
// The auth and user-info dropdowns are built in a later phase; the avatar is a
// trigger placeholder and the auth buttons link to the standard pages as a fallback.
function UserMenu({ isCurrentUser = false, locale = 'en' }) {
  const { userData } = useUserData(isCurrentUser)

  if (!isCurrentUser) {
    return (
      <div className="unified-nav__user">
        <Button type="secondary" size="small" href="/users/login">
          {i18n.t('navigation.user.login', { ns: 'rails', lng: locale })}
        </Button>
        <Button size="small" href="/users/registration">
          {i18n.t('navigation.user.register', { ns: 'rails', lng: locale })}
        </Button>
      </div>
    )
  }

  return (
    <div className="unified-nav__user">
      <button
        type="button"
        className="unified-nav__user-avatar"
        aria-haspopup="menu"
        aria-expanded={false}
        aria-label={userData?.attributes?.username || 'Account'}
        onClick={NOOP}
      >
        <Avatar
          size="32"
          username={userData?.attributes?.username}
          img={userData?.attributes?.avatar?.large_url}
          useSingleLetter
        />
      </button>
    </div>
  )
}

UserMenu.propTypes = {
  isCurrentUser: bool,
  locale: string,
}

export default UserMenu
